if (!customElements.get('nine-nine-toggle-bar')) {
  class NineNineToggleBar extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-nine-nine-view]')];
      this.collectionTab = this.querySelector('[data-nine-nine-view="collection"]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.followsHeader = !CSS.supports('overflow', 'clip');
      this.jumping = false;
      this.ticking = false;
      this.headerSection = document.querySelector('.section-header');
      this.header = this.headerSection?.querySelector('.header-wrapper') ?? this.headerSection;

      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onJumpEnd = this.onJumpEnd.bind(this);

      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      if (this.followsHeader && this.headerSection) {
        this.headerObserver = new MutationObserver(() => this.followHeader());
        this.headerObserver.observe(this.headerSection, { attributes: true, attributeFilter: ['class'] });
      }
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('scrollend', this.onJumpEnd);
      clearTimeout(this.jumpTimer);
      this.headerObserver?.disconnect();
      cancelAnimationFrame(this.followFrame);
    }

    placeBar() {
      const headerBottom = this.header?.getBoundingClientRect().bottom ?? 0;
      this.style.setProperty('--nine-nine-toggle-top', `${Math.max(0, headerBottom)}px`);
    }

    followHeader() {
      const until = performance.now() + 300;
      cancelAnimationFrame(this.followFrame);
      const step = () => {
        this.placeBar();
        if (performance.now() < until) this.followFrame = requestAnimationFrame(step);
      };
      step();
    }

    get target() {
      const { anchor } = this.dataset;
      if (anchor) return document.getElementById(anchor);
      return [...document.querySelectorAll('.shopify-section.featured-coll')]
        .find((section) => this.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING) ?? null;
    }

    onClick(event) {
      const tab = event.target.closest('[data-nine-nine-view]');
      if (!tab) return;

      const { nineNineView: view } = tab.dataset;
      const target = this.target;
      if (view === 'collection' && !target) return;

      const top = view === 'collection'
        ? target.getBoundingClientRect().top + window.scrollY - this.offsetHeight + 1
        : 0;

      this.setActive(view);
      this.jumping = true;
      clearTimeout(this.jumpTimer);
      window.addEventListener('scrollend', this.onJumpEnd, { once: true });
      this.jumpTimer = setTimeout(this.onJumpEnd, 1600);
      window.scrollTo({ top, behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    onJumpEnd() {
      clearTimeout(this.jumpTimer);
      window.removeEventListener('scrollend', this.onJumpEnd);
      this.jumping = false;
      this.update();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    setActive(view) {
      for (const tab of this.tabs) {
        const active = tab.dataset.nineNineView === view;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      }
    }

    update() {
      if (this.followsHeader) this.placeBar();
      const viewportMiddle = window.innerHeight * 0.5;
      const target = this.target;

      if (this.collectionTab) this.collectionTab.hidden = !target;

      if (!this.jumping && target) {
        this.setActive(target.getBoundingClientRect().top < viewportMiddle ? 'collection' : 'lookbook');
      }
    }
  }

  customElements.define('nine-nine-toggle-bar', NineNineToggleBar);
}
